<template>
<div id="app">
<div>
 <!-- <h1>ValidRegistrationToken Page</h1> -->
 </div>
</div>
</template>
<script>

import { VALIDATE_TEMP_TOKEN } from '../store';

export default {
  name: 'TokenVerification',
  created() {
    this.token = this.$route.query.temptoken;
    this.isValidToken(this.token);
  },
  components: {

  },
  mounted() {
  },
  data() {
    return {
      token: null,
      loginErorrMessage: null,
    };
  },
  computed: {
  },
  methods: {
    async isValidToken(tempToken) {
      try {
        await this.$store.dispatch(VALIDATE_TEMP_TOKEN, { tempToken });
      } catch (err) {
        // this.$parent.$parent.notificationToasts.length = 0;
        switch (err.status) {
          case 403:
            // this.$router.push('/unauth');
            this.loginErorrMessage = 'Invalid token';
            break;
          case 423:
            this.loginErorrMessage = 'Your account is locked. Please contact ASCA Storage Tanks to un-lock your account at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca.';
            break;
          default:
            this.loginErorrMessage = 'Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Tanks at ascatanks@safetycodes.ab.ca or by calling 1-888-413-0099';
        }
        if (this.loginErorrMessage) {
          this.$parent.$parent.notificationToasts.push({
            title: 'Error!',
            content: this.loginErorrMessage,
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          });
        }
      }
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
  },
};
</script>
<style>

</style>
